var _a;
import { DeliveryType } from "@schema/types";
export var CURRENCY = "Kr";
export var LOCALE = "da-DK";
export var DELIVERY_TYPE_LABELS = (_a = {},
    _a[DeliveryType.Pickup] = "Pickup",
    _a[DeliveryType.Doorstep] = "Home-delivery",
    _a);
export var DAYS = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
];
export var DEBOUNCE_TIMEOUT_IN_MS = 250;
export var SHIPPING_TYPE = "shipping_type";
export var SHIPPING_PLACE = "shipping_place";
export var SHIPPING_SLOT = "shipping_slot";
export var SHIPPING_ZIP_CODE = "shipping_zip_code";
export var SHIPPING_COUNTRY = "shipping_country";
export var PROPERTY_SHIPPING_TYPE = "properties[shipping_type]";
export var PROPERTY_SHIPPING_PLACE = "properties[shipping_place]";
export var PROPERTY_SHIPPING_SLOT = "properties[shipping_slot]";
export var PROPERTY_SHIPPING_ZIP_CODE = "properties[shipping_zip_code]";
export var PROPERTY_SHIPPING_COUNTRY = "properties[shipping_country]";
